import { Activity, Plus, Mail, Phone, FileText, AlertTriangle } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { PageHeader } from '@/components/PageHeader';

export default function CollectionActivities() {
  const stats = [
    {
      title: "Total Activities",
      value: "0",
      description: "All collection activities",
      icon: Activity,
    },
    {
      title: "Pending",
      value: "0",
      description: "Activities waiting to be sent",
      icon: AlertTriangle,
    },
    {
      title: "Sent Today",
      value: "0",
      description: "Activities sent today",
      icon: Mail,
    },
    {
      title: "Success Rate",
      value: "0%",
      description: "Response rate",
      icon: FileText,
    }
  ];

  return (
    <div className="space-y-6">
      <PageHeader
        title="Collection Activities"
        description="Track and manage all collection activities and communications"
        action={
          <Button className="gap-2">
            <Plus className="h-4 w-4" />
            New Activity
          </Button>
        }
      />

      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {stats.map((stat, index) => (
          <Card key={index}>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle className="text-sm font-medium text-muted-foreground">
                {stat.title}
              </CardTitle>
              <stat.icon className="h-4 w-4 text-muted-foreground" />
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">{stat.value}</div>
              <p className="text-xs text-muted-foreground">
                {stat.description}
              </p>
            </CardContent>
          </Card>
        ))}
      </div>

      {/* Activities */}
      <Card>
        <CardHeader>
          <CardTitle>Collection Activities</CardTitle>
          <CardDescription>
            View and manage all customer collection communications and activities
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="text-center py-12">
            <Activity className="h-16 w-16 text-muted-foreground mx-auto mb-4" />
            <h3 className="text-lg font-semibold mb-2">No activities yet</h3>
            <p className="text-muted-foreground mb-4">
              Collection activities will appear here when customers have overdue bills
            </p>
            <Button>
              <Plus className="h-4 w-4 mr-2" />
              Create Activity
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}